// extracted by mini-css-extract-plugin
module.exports = {"code-input":"_ScratchAndWin_code-input__0-7m","submit":"_ScratchAndWin_submit_Sdx4L"};